import { render, staticRenderFns } from "./DesignMore.vue?vue&type=template&id=5ea7c563&scoped=true&"
import script from "./DesignMore.vue?vue&type=script&lang=js&"
export * from "./DesignMore.vue?vue&type=script&lang=js&"
import style0 from "./DesignMore.vue?vue&type=style&index=0&id=5ea7c563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7c563",
  null
  
)

component.options.__file = "DesignMore.vue"
export default component.exports